import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import API from '../../api/axios';
import { FiFileText, FiCreditCard, FiClock, FiCheckCircle } from 'react-icons/fi';
import { formatCreatedAt } from '../../utils/dateUtils';

const PatientDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({ total: 0, pending: 0, paid: 0, payments: 0 });
  const [recentInvoices, setRecentInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [allRes, pendingRes, paidRes, paymentsRes] = await Promise.all([
          API.get('/invoices?limit=5'),
          API.get('/invoices?status=pending&limit=1'),
          API.get('/invoices?status=paid&limit=1'),
          API.get('/payments/my-payments?limit=1'),
        ]);

        setRecentInvoices(allRes.data.data.invoices);
        setStats({
          total: allRes.data.data.pagination.total,
          pending: pendingRes.data.data.pagination.total,
          paid: paidRes.data.data.pagination.total,
          payments: paymentsRes.data.data.pagination.total,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getStatusBadge = (status) => {
    const map = {
      pending: 'En attente',
      partial: 'Partiel',
      paid: 'Payée',
      overdue: 'En retard',
      cancelled: 'Annulée',
    };
    return <span className={`badge badge-${status}`}>{map[status] || status}</span>;
  };

  if (loading) {
    return <div className="loading-page"><div className="spinner"></div><p>Chargement...</p></div>;
  }

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 600 }}>
          Bonjour, {user?.first_name} !
        </h2>
        <p style={{ color: 'var(--gray-500)', fontSize: 14 }}>
          Voici un résumé de vos factures médicales.
        </p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue"><FiFileText /></div>
          <div className="stat-info">
            <h3>{stats.total}</h3>
            <p>Total factures</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon orange"><FiClock /></div>
          <div className="stat-info">
            <h3>{stats.pending}</h3>
            <p>En attente</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><FiCheckCircle /></div>
          <div className="stat-info">
            <h3>{stats.paid}</h3>
            <p>Payées</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon blue"><FiCreditCard /></div>
          <div className="stat-info">
            <h3>{stats.payments}</h3>
            <p>Paiements effectués</p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Factures récentes</span>
          <Link to="/patient/invoices" className="btn btn-outline btn-sm">Voir tout</Link>
        </div>
        {recentInvoices.length === 0 ? (
          <div className="empty-state">
            <h3>Aucune facture</h3>
            <p>Vous n'avez pas encore de facture médicale.</p>
          </div>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>N° Facture</th>
                  <th>Motif</th>
                  <th>Montant</th>
                  <th>Statut</th>
                  <th>Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {recentInvoices.map((inv) => (
                  <tr key={inv.id}>
                    <td style={{ fontWeight: 600 }}>{inv.invoice_number}</td>
                    <td>{inv.motif}</td>
                    <td style={{ fontWeight: 600 }}>
                      {parseFloat(inv.amount).toLocaleString()} {inv.currency}
                    </td>
                    <td>{getStatusBadge(inv.status)}</td>
                    <td>{formatCreatedAt(inv)}</td>
                    <td>
                      <Link to={`/patient/invoices/${inv.id}`} className="btn btn-outline btn-sm">
                        Détails
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientDashboard;
